module.exports = __webpack_public_path__ + "img/stop-6.490b2327.jpg";